import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TPropertiesOfPatchChangesForModGroup } from 'types';
import { modGroupProperties } from 'appConstants/modifierGroups';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './index.module.scss';

interface IProps {
	setProperties: (value: TPropertiesOfPatchChangesForModGroup[]) => void;
	selectedProperties: TPropertiesOfPatchChangesForModGroup[];
}

export const PropertiesMultipleSelect: React.FC<IProps> = React.memo(({ setProperties, selectedProperties }) => {
	const { t } = useTranslation('form');

	const translatedProperties = useMemo(() => {
		return modGroupProperties.map((property) => ({ id: property.id, name: t(property.name) }));
	}, [t]);

	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = selectedProperties.filter((el) => el !== id);
			setProperties(updatedSelectedItems);
		},
		[selectedProperties, setProperties],
	);

	const propertiesList = useMemo(() => {
		return selectedProperties.map((el) => {
			const label = translatedProperties?.find((item) => item.id === el)?.name || '';

			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [selectedProperties, translatedProperties, handleRemove]);

	return (
		<div className={style.container} data-test="PropertiesMultipleSelect">
			<MultipleSelect
				setProperties={setProperties}
				properties={translatedProperties}
				selectedProperties={selectedProperties}
			/>
			<div className={style.groupsList}>{propertiesList}</div>
		</div>
	);
});
